import { InvestigationStatus } from 'src/models';

import { useAccountApplicationSelector } from './useAccountApplicationSelector';
import { useAccountSelector } from './useAccountSelector';
import { useInvestigationListSelector } from './useInvestigationListSelector';

interface UseFindAccountStatusReturn {
  accountApplicationStatus?: InvestigationStatus;
  isAnyAccountApplicationDocumentRequested?: boolean;
}

export const useFindAccountApplicationStatus = (): UseFindAccountStatusReturn => {
  const { account } = useAccountSelector();
  const { status: investigationStatus, isAnyDocumentRequested } = useInvestigationListSelector();
  const { accountApplication, isAnyAccountApplicationDocumentRequested } = useAccountApplicationSelector();

  const findStatus = () => {
    if (!account?.accountId) {
      return;
    }

    if (account?.type.isEntity && !account.isEntityAccountTypeActive) {
      return accountApplication?.status;
    }

    return investigationStatus;
  };

  const findIsAnyDocumentRequested = () => {
    if (!account?.accountId) {
      return false;
    }

    if (account?.type.isEntity) {
      return isAnyAccountApplicationDocumentRequested;
    }

    return isAnyDocumentRequested;
  };

  return {
    accountApplicationStatus: findStatus(),
    isAnyAccountApplicationDocumentRequested: findIsAnyDocumentRequested(),
  };
};
